import React from "react";
import {
    Accordion,
    Paper,
    SimpleGrid,
    Stack,
    Text,
    ThemeIcon,
} from "@mantine/core";
import { IconGlassFull } from "@tabler/icons-react";
import type { DrinkBarStatusDto } from "../types";
import type { Texts } from "../texts";

type Props = {
    drinkBars: DrinkBarStatusDto[];
    onSelectBar: (
        eventBarId: number,
        barName: string
    ) => void;
    t: Texts;
};

export default function DrinksSection({
    drinkBars,
    onSelectBar,
    t,
}: Props) {
    if (drinkBars.length === 0) return null;

    return (
        <Accordion.Item value="drinks">
            <Accordion.Control
                icon={
                    <ThemeIcon
                        color="red"
                        variant="light"
                        radius="xl"
                    >
                        <IconGlassFull size={18} />
                    </ThemeIcon>
                }
            >
                {t.drinks}
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="sm">
                    <Text fw={600}>
                        {t.myBars}
                    </Text>

                    <SimpleGrid
                        cols={{
                            base: 1,
                            sm: 2,
                            md: 3,
                        }}
                    >
                        {drinkBars.map((bar) => (
                            <Paper
                                key={bar.eventBarId}
                                withBorder
                                radius="xl"
                                p="lg"
                                onClick={() =>
                                    onSelectBar(
                                        bar.eventBarId,
                                        bar.barName
                                    )
                                }
                                style={{
                                    borderColor: "#fa5252",
                                    borderWidth: 2,
                                    cursor: "pointer",
                                    transition:
                                        "transform 0.15s ease, box-shadow 0.15s ease",
                                }}
                            >
                                <Stack gap={8}>
                                    <Text
                                        fw={700}
                                        size="lg"
                                    >
                                        {bar.barName}
                                    </Text>

                                    <Text size="md">
                                        {t.drinksRemaining.replace(
                                            "{count}",
                                            String(
                                                bar.remainingDrinks
                                            )
                                        )}
                                    </Text>
                                </Stack>
                            </Paper>
                        ))}
                    </SimpleGrid>
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}